import request from '@/utils/request'


// 查询七乐彩列表
export function listQlc(query) {
    return request({
        url: '/admin/lottery/qlc/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期七乐彩数据
export function latestQlc() {
    return request({
        url: '/admin/lottery/qlc/latest',
        method: 'get',
    })
}

// 初始化七乐彩数据
export function initAllQlc() {
    return request({
        url: '/admin/lottery/qlc/initAll',
        method: 'post'
    })
}

// 补全七乐彩历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/qlc/fillHistoryData',
        method: 'post'
    })
}

// 获取七乐彩号码出现次数
export function getQlcNumData() {
    return request({
        url: '/admin/lottery/qlc/getNumData',
        method: 'get',
    })
}

// 初始化七乐彩统计数据
export function initAllQlcC() {
    return request({
        url: '/admin/lottery/qlc/initAllC',
        method: 'post'
    })
}

// 刷新七乐彩缓存
export function refreshQlcCache() {
    return request({
        url: '/admin/lottery/qlc/refreshCache',
        method: 'delete',
    })
}
// 生成七乐彩
export function generateQlc(data) {
    return request({
        url: '/admin/lottery/qlc/generate',
        method: 'post',
        data:data
    })
}

// 查询七乐彩中奖数据
export function getQlcWinningData(query){
    return request({
        url: '/admin/lottery/qlc/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询七乐彩历史同期中奖数据
export function getNextQlcHistory(period){
    return request({
        url: '/admin/lottery/qlc/getNextHistory?period='+period,
        method: 'get'
    })
}
